import React from 'react'
import {Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from "./checkoutForm";

const stripePromise = loadStripe('pk_live_EuIu6nGUxQrmtYisr7eaF2Sr00U5ieRam1');

const Checkout = ({clientSecret})=>   {
    const options = {
        clientSecret,
    };
    return (
        <Elements stripe={stripePromise} options={options}>
            <CheckoutForm />
        </Elements>
    );
}


export default Checkout
